const PREVIEW_COLOR_MATCHER = /#333F92|#2D32AA|#1A1F2C|#252B3C|#000000/gi
const PREVIEW_ENCODED_COLOR_MATCHER = /%23333F92|%232D32AA|%231A1F2C|%23252B3C|%23000000/gi
const EMBEDDED_SVG_IMAGE_MATCHER = /href="data:image\/svg\+xml;utf8,([^"]+)"/i

export const findLegend = (options, value, fallback = '-') => options.find(option => option.value === value)?.label || fallback

const replaceSvgColors = (svgMarkup, color) =>
  svgMarkup
    .replace(PREVIEW_COLOR_MATCHER, color)
    .replace(PREVIEW_ENCODED_COLOR_MATCHER, color?.replace(/#/g, '%23'))

const createColoredSvgMarkup = (svgMarkup, color) => {
  if (!color) return svgMarkup

  const embeddedSvgMatch = svgMarkup.match(EMBEDDED_SVG_IMAGE_MATCHER)
  if (!embeddedSvgMatch) return replaceSvgColors(svgMarkup, color)

  const embeddedSvgMarkup = decodeURIComponent(embeddedSvgMatch[1])
  const coloredEmbeddedSvg = replaceSvgColors(embeddedSvgMarkup, color)

  return svgMarkup.replace(embeddedSvgMatch[1], encodeURIComponent(coloredEmbeddedSvg))
}

const createSvgUrl = markup => URL.createObjectURL(new Blob([markup], { type: 'image/svg+xml' }))

export const createColoredPreviewImage = async (image, color) => {
  const response = await fetch(image)
  const svgMarkup = await response.text()

  return createSvgUrl(createColoredSvgMarkup(svgMarkup, color))
}

export const createQrCodeBlob = (format, qrCodeData) => {
  if (format === 'SVG') return new Blob([qrCodeData], { type: 'image/svg+xml' })
  if (format === 'PNG') {
    const pngBytes = Uint8Array.from(atob(qrCodeData), character => character.charCodeAt(0))
    return new Blob([pngBytes], { type: 'image/png' })
  }

  return null
}

export const copyQrCodeToClipboard = async (format, qrCodeData, blob) => {
  if (!navigator.clipboard || typeof ClipboardItem === 'undefined') {
    console.warn('Clipboard API not supported.')
    return false
  }

  const clipboardData = format === 'SVG'
    ? {
      'text/html': new Blob([
        `<img src="data:image/svg+xml,${encodeURIComponent(qrCodeData)}" alt="QR code" />`
      ], { type: 'text/html' }),
      'text/plain': new Blob([qrCodeData], { type: 'text/plain' })
    }
    : { [blob.type]: blob }

  await navigator.clipboard.write([new ClipboardItem(clipboardData)])
  return true
}

export const getVariantPreviewColor = (variant, isWhiteBackground, selectedColor, colors) => {
  if (isWhiteBackground) return colors.white
  return variant === 'DONAITALIA' ? colors.nexi : selectedColor
}
